import type { ReactElement } from 'react';
import { Chip } from '@citibox-panel/ui';

export interface RoleChipProps {
  label: string;
  // An id the panel cannot name (a role or permission managed only from backend).
  unknown?: boolean;
}

// One chip for roles and per-person permissions, in the table and in the dialog.
export function RoleChip({ label, unknown = false }: RoleChipProps): ReactElement {
  return <Chip label={label} size="small" variant={unknown ? 'outlined' : 'filled'} />;
}
